import type { HelpFile } from '../../types/help'
import { ScriptEditorCoreTestIds } from '../../../testids/ScriptEditorCoreTestIds'

export const scriptEditorCoreHelp: HelpFile = {
  docPage: '/docs/jobs/script-editor',
  texts: {
    [ScriptEditorCoreTestIds.scriptEditorCore]:
      'Code editor with syntax checking and AI assistance for writing job and connector scripts.',
    [ScriptEditorCoreTestIds.assistError]:
      'Error returned by the AI assistant — try refining your prompt or retry.',
    [ScriptEditorCoreTestIds.assistPanel]:
      'Side panel where the AI assistant suggests script edits and improvements.',
    [ScriptEditorCoreTestIds.assistPanelBody]: null,
    [ScriptEditorCoreTestIds.assistSuggestion]:
      'A specific suggestion returned by the AI assistant; apply it to replace the current script.',
    [ScriptEditorCoreTestIds.badgeSyntaxOk]: null,
    [ScriptEditorCoreTestIds.btnApplySuggestion]: null,
    [ScriptEditorCoreTestIds.btnCancelReplace]: null,
    [ScriptEditorCoreTestIds.btnCheckSyntax]:
      'Validate the script for syntax errors without running it.',
    [ScriptEditorCoreTestIds.btnCloseAssist]: null,
    [ScriptEditorCoreTestIds.btnConfirmReplace]: null,
    [ScriptEditorCoreTestIds.btnFixWithAi]:
      'Ask the AI assistant to fix the highlighted syntax error.',
    [ScriptEditorCoreTestIds.btnInsertAtCursor]:
      'Insert the suggestion at the current cursor position rather than replacing the whole script.',
    [ScriptEditorCoreTestIds.btnInsertSql]: null,
    [ScriptEditorCoreTestIds.btnShowAllErrors]: null,
    [ScriptEditorCoreTestIds.btnSuggest]: null,
    [ScriptEditorCoreTestIds.btnToggleAssist]: null,
    [ScriptEditorCoreTestIds.editorContainer]: null,
    [ScriptEditorCoreTestIds.editorCoreSqlToolbar]:
      'SQL-specific toolbar for inserting a schema-aware SQL snippet into the script.',
    [ScriptEditorCoreTestIds.editorCoreToolbar]: null,
    [ScriptEditorCoreTestIds.errorSummaryBar]:
      'Compact summary of detected syntax errors in the script.',
    [ScriptEditorCoreTestIds.inputAssistRequest]: null,
    [ScriptEditorCoreTestIds.rateLimitWarning]:
      'AI assistant requests are rate-limited; wait before making another request.',
  },
}
